import React, { useEffect } from "react";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import { Link } from "react-router-dom";
import LazyLoad from "react-lazyload";
function OurHistory() {
  useEffect(() => {
    document.title = "Our History -  CARMEL CONVENT SCHOOL, DHARUHERA";
  }, []);
  return (
    <>
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li>
                  <Link to="/"> Home </Link>
                </li>
                <li>About Us</li>
                <li>Our History</li>
              </ul>
            </div>
            <div className="col-lg-12">
              <h2 className="innerheading">Our History</h2>
            </div>
          </div>
          <div className="row">
            <div className="clearfix">
              <LazyLoad>
                {" "}
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/MotherVeronica.png"
                  className="img-fluid col-sm-12 col-md-3 founderimg float-md-end mb-3"
                  alt=""
                />
              </LazyLoad>
              <h5>History Of The Apostolic Carmel Congregation</h5>
              <p>
                The Congregation of the Sisters of the Apostolic Carmel is an
                Indian Congregation which took its roots in the year 1870 in its
                Foundress Mother Veronica a holy and dedicated woman, who was
                divinely inspired to reach out to many girls of her day. We draw
                our inspiration from Christ, who willed the total development of
                every person, as also from our Foundress, Mother Veronica.{" "}
              </p>
              <p>
                Carmel Convent School, Dharuhera, founded on September 14, 2019,
                is one of the institutions conducted by the Apostolic Carmel
                Sisters. One small seed thrown in the rich soil of India and
                destined to grow, was the beginning of our Congregation. It was
                founded in Bayonne, France on July 16th, 1868 by Mother Veronica
                of the Passion and established in India on November 19th 1870.
                Sophie Leeves, her former name, born on 1st October 1823, was an
                English Lady, daughter of Marina Leeves and Rev. Henry Daniel
                Leeves, a military Chaplain to the British Ambassador, posted in
                Constantinople.{" "}
              </p>
              <p>
                She was well educated and an extremely versatile women. Besides
                being a writer, she was also an excellent musician. She knew
                several languages – Latin, French, Italian, German, Greek, in
                addition to her own mother tongue, English. She had everything
                but was not truly happy. She was searching for the truth and she
                found it in the Church. She had deep faith and believed that God
                would heal the wound she had caused her widowed mother, in His
                own time and in His own way.{" "}
              </p>
              <p>
                She was still searching – a far higher destiny awaited her. She
                had a call to give herself totally to the service of God. It was
                the beginning of a dialogue between God and her, that was to
                become increasingly urgent. She joined the Congregation of the
                sisters of St. Joseph of Apparition, on 14th September, 1851, in
                Athens, Greece. As a nun, Sophie received a new name – Sister
                Veronica of the Passion.{" "}
              </p>
              <p>
                Her benevolent disposition and wideness of heart which is
                Sophie's character, as well as her fiery, arduous perseverance
                in the face of difficulties, her love for the poor and above all
                her deep faith in God, she had inherited from her parents. She
                was attuned to God – carrying out His will, joyfully and at any
                risk. She was a strange destiny, God had developed her character
                through initial interaction with His Providential and supporting
                Love. He had led her through a series of crisis until through
                her had fulfilled His plan of a Carmel – "A Carmel for the
                Missions."{" "}
              </p>
              <p>
                There are moments when the plan of God and searching of human
                beings converge, and such a thing happened with the meeting in
                Calicut, in Kerala, India, in 1862 between Sister Veronica and
                Father Marie Ephrem, a French Carmelite. He invited these
                Sisters as there was a void felt of good Catholic schools for
                the Education of youth. It was this that determined the
                foundation of our Congregation through the instrumentality of
                Mother Veronica. Having worked in several schools in Europe, as
                a Sister of St. Joseph, she was sent to India, Calicut, in 1862.
                Her teaching apostolate here, was richly blest. She showed a
                special love for the less fortunate. She wanted all – the rich
                and the poor – to enjoy the "goods of the lands" – God's gift
                for His people. She learnt Malayalam, eager to fit herself to
                give an all round development to the girls in this new field of
                labour where Malayalam was the chief language. The school
                progressed rapidly. Many Christian, Hindu, Muslim, Parsee
                families sent their children to this school where all
                distinction of caste and creed was forgotten.{" "}
              </p>
              <p>
                It was while here, that she heard another call-a call to enter
                "Carmel". Relying on God and empowered by Him, she surmounted
                all difficulties, ridicule and insults and in 1867 she went back
                to France to start the foundation of Carmel. She faced all the
                challenges never giving up hope in God and in 1867 she started a
                small house in Bayonne, France and there the Apostolic Carmel
                was born. She trained a batch of three Sisters and sent them to
                India. As with other works taken in faith, once again the
                History of the Apostolic Carmel proves the truth of the Biblical
                maxim : "Unless a grain of wheat falls into the ground and dies,
                it remains alone, but if it dies, it bears much fruit." Jn. 12:
                24{" "}
              </p>
              <p>
                The house in Bayonne had to be closed. But this closure gave the
                A.C. a singular characteristic-making it completely indigenous.{" "}
              </p>
              <p>
                It was on 19th November 1870, that the three Sisters landed in
                Mangalore and started the St. Ann's School for girls. Mother
                Veronica had fulfilled the purpose God had for her – "A Carmel
                for the Missions." She had yet another call – a call to the
                cloistered Carmel. Truly she could say she lived up to her
                maxim. "Obedience is my life."{" "}
              </p>
              <p>
                For the next 33 years of her life, until her saintly death on
                November 16, 1906, she continued to water the tiny plant, that
                was transplanted to India on November 1870, with her prayer and
                sacrifices.{" "}
              </p>
              <p>
                She left to the Congregation she founded her spirit: a personal
                surrender to God's all sufficing love and the profound urge to
                respond to Him in Apostolic work. From the beginning, the
                Apostolic Carmel has striven to keep alive this spirit –
                excellence in Education and other Works of Mercy, her love for
                the poor, her simplicity, contentment and joy. The education of
                "girls of all classes and creeds" has been a challenging enough
                mandate.{" "}
              </p>
              <p>
                The same charism i.e. God's all sufficing love and zeal that
                attracted our Foundress and kept alive by her, drew all of us to
                the same Congregation.{" "}
              </p>
              <p>
                As her true daughters, while our Education is directed towards
                the total development of the person we too are primarily
                concerned with instilling Gospel values in those we educate and
                forming responsible citizens in the country who are ready to
                take their place in social, political and cultural life with
                selflessness and zeal. Our special focus will be the formation
                of committed people who are filled with a sense of mission to
                their country and to the world.{" "}
              </p>
              <p>
                With this in view, the Apostolic Carmel provides a suitable
                catechesis for their Christian students in all their schools and
                colleges and other institutions and value education for their
                non-Christian students which forms a compulsory part of our
                curriculum. This does not in any way, interfere with the
                religious beliefs of other denominations.{" "}
              </p>
              <p>
                Mary, the Queen and Beauty of Carmel, is our Patroness. Like her
                our call is primarily to belong to Him, to be immersed in Him,
                and it is His overflowing love that urges us to be completely
                available to the world by reaching out in self emptying love. It
                is He who empowers us to take up this challenge. This conviction
                gives meaning to all our striving and urges us to go forward
                putting our trust in the Lord of hope, to be an Apostolic
                Community, a sign that proclaims and at the same time lives the
                message that God is the Supreme value in our lives. Today, the
                sisters cater to the needs of children in high schools, teacher
                training institutions, degree colleges and technical schools,
                all of which are conducted both in English medium and Regional
                languages. They also run creches, children's homes, hostels and
                boarding houses all over India, in Sri Lanka, Kuwait, Pakistan,
                Africa, Bahrain, Rome and Tanzania. The Educational institutions
                of the Congregation of the Apostolic Carmel, a Catholic Minority
                (under Article 30 (1) of the Constitution of India) cater to the
                educational needs of Catholic children. However, they are also
                open to children of all classes and creeds.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default OurHistory;
